import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { ChevronRightIcon } from "@heroicons/react/solid";
import { navigation } from "./Sidebar";
import React from "react";

export default function Layout({
  title,
  children,
  pageTag,
  current,
  curentPage,
}) {
  var menusData = navigation.find((x) => x.tag === pageTag);
  var currentIndex = menusData.children.findIndex((x) => x.href === current);

  return (
    <>
      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
        <Sidebar curentPage={curentPage} parentPage={pageTag} />
        {/* <NewBar/> */}
      </div>
      <div className="md:pl-64 flex flex-col flex-1">
        <div className="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white ">
          <Navbar />
        </div>
        <main>
          <div className="">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="flex mb-4">
                <Link to={menusData?.children?.[0]?.href || "/"} className="flex">
                  <p className="text-xs text-gray-500">{menusData.name}</p>
                  <ChevronRightIcon className="w-3 text-gray-500" />
                </Link>
                {menusData?.children?.map((element, index) => {
                  return index <= currentIndex ? (
                    <React.Fragment key={element.href}>
                      <Link to={element.href} className="flex">
                        <p className="text-xs text-gray-500">{element.name}</p>
                        <ChevronRightIcon className="w-3 text-gray-500" />
                      </Link>
                    </React.Fragment>
                  ) : (
                    <React.Fragment key={element.href + "empty"}>
                    </React.Fragment>
                  );
                })}
              </div>
              <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
            </div>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="py-4">
              <div>{children}</div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
